import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useSettings } from '../../contexts/SettingsContext';
import { APP_BRAND } from '../../config/branding';
import { useDisplayTimeZone, useEffectiveDisplayTimeZone } from '../../hooks/useDisplayTimeZone';
import { formatTimeZoneLabel, formatTimeZoneOffset } from '../../utils/timeZone';
import { AppFooterLastSync } from './AppFooterLastSync';

const Footer: React.FC = () => {
  const { colors } = useTheme();
  const { appConfig } = useSettings();
  const preference = useDisplayTimeZone();
  const effectiveZone = useEffectiveDisplayTimeZone();
  const currentYear = new Date().getFullYear();
  const productName = appConfig.system.appName?.trim() || APP_BRAND.name;
  const zoneLabel = formatTimeZoneLabel(effectiveZone);
  const offsetLabel = formatTimeZoneOffset(effectiveZone);
  const timeZoneText = preference
    ? `${zoneLabel} (${offsetLabel})`
    : `Browser default — ${zoneLabel} (${offsetLabel})`;

  return (
    <footer className={`${colors.surface} border-t ${colors.border} mt-auto flex-shrink-0`}>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-2 px-4 py-2 min-h-[2rem]">
        <div className="flex min-w-0 justify-start order-2 sm:order-1">
          <AppFooterLastSync />
        </div>
        <div className={`text-xs text-center leading-tight order-1 sm:order-2 ${colors.textSecondary}`}>
          © {currentYear} {productName}. All rights reserved.
        </div>
        <div
          className={`text-xs text-center sm:text-right leading-tight order-3 ${colors.textMuted}`}
          title="Display timezone for dates and timestamps"
        >
          Timezone: {timeZoneText}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
